module.exports = __webpack_public_path__ + "media/images/banner_app-a7c6988b70ba8f421d9f534d59b6bdaf.png";